import { Component, Input, inject } from '@angular/core';
import { EcommerceTrackingService } from '@boels/helpers';
import { BimDocument, BimFile } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCube, faDownload } from '@fortawesome/free-solid-svg-icons';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';

@Component({
  selector: 'boels-bim-model-list-item',
  templateUrl: './bim-model-list-item.component.html',
  styleUrls: ['./bim-model-list-item.component.scss'],
  imports: [TranslocoModule, FontAwesomeModule],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['productDetails'],
    },
  ],
})
export class BimModelListItemComponent {
  private ecommerceTrackingService = inject(EcommerceTrackingService);

  @Input()
  bimDocument: BimDocument;

  faCube = faCube;
  faDownload = faDownload;

  onDownload(file: BimFile): void {
    this.ecommerceTrackingService.setBimModelFileDownloadEvent(
      file,
      this.bimDocument,
    );
  }
}
